import React from 'react'
import FilterCard from '../../components/filter-card'
import { UserTypeEnum } from '../../utils/enums'

const StudentsFilter = ({ filters, onFilterChange, onFilterSubmit, onClearFilters, onRefresh, loading }) => {
  const fields = [
    {
      type: 'input',
      name: 'search',
      placeholder: 'STUDENTS_FILTERS_SEARCH_PLACEHOLDER',
      icon: 'zmdi zmdi-search'
    },
    {
      type: 'input',
      name: 'city',
      placeholder: 'STUDENTS_FILTERS_CITY_PLACEHOLDER',
      icon: 'zmdi zmdi-pin'
    },
    {
      type: 'input',
      name: 'country',
      placeholder: 'STUDENTS_FILTERS_COUNTRY_PLACEHOLDER',
      icon: 'zmdi zmdi-globe-alt'
    },
    {
      type: 'input',
      name: 'nationality',
      placeholder: 'STUDENTS_FILTERS_NATIONALITY_PLACEHOLDER',
      icon: 'zmdi zmdi-flag'
    },
    {
      type: 'select',
      name: 'agentId',
      placeholder: 'Acenta seçiniz',
      roleBased: true,
      roleAccess: UserTypeEnum.ADMIN,
      fetchUrl: 'agents/active',
      prependOptions: [{ value: '', label: 'Tümü' }],
      valueKey: 'id',
      labelKey: 'companyName',
      mapOption: (agent) => {
        const value = agent.id || agent.userId || agent.agentId
        const label =
          agent.companyName ||
          agent.name ||
          agent.fullName ||
          (agent.user && `${agent.user.firstName || ''} ${agent.user.lastName || ''}`.trim())

        if (!value || !label) return null

        return {
          value: value.toString(),
          label: label.toString()
        }
      },
      icon: 'zmdi zmdi-account-box'
    }
  ]

  const defaultFilters = {
    search: '',
    city: '',
    country: '',
    nationality: '',
    agentId: ''
  }

  return (
    <FilterCard
      filters={filters}
      onFilterChange={onFilterChange}
      onFilterSubmit={onFilterSubmit}
      onClearFilters={onClearFilters}
      onRefresh={onRefresh}
      loading={loading}
      title="STUDENTS_FILTERS_TITLE"
      titleHide="STUDENTS_FILTERS_HIDE"
      titleShow="STUDENTS_FILTERS_SHOW"
      fields={fields}
      defaultFilters={defaultFilters}
      autoSubmitFields={[]}
    />
  )
}

export default StudentsFilter



